import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Dialog
 * Demos:
 *
 * - [Dialog](https://dev--6556d17f924e868b000ddaf5.chromatic.com/?path=/story/components-dialog--help/)
 *
 * @param props - children, open, setOpen, json, headerIcon, headerTitle, onClose, hiddenClose, justPreview
 * @example
 * <Dialog headerTitle="Dialog Title" open={true} setOpen={setOpen} onClose={onClose}>
 *  {children}
 * </Dialog>
 * @returns React.ReactElement
 */
var Dialog = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
Dialog.defaultProps = {};
var SampleProps = {};
export default Dialog;
export { SampleProps as DialogSample, };
